import React from 'react';
import GlobalHelper from '../../../../Common/Helpers/GlobalHelper';
 
const RowTablaMovimientosSinConfirmar = (props) => {
        const { movimientosSinConfirmar, index } = props; 
        let backColor = index % 2 != 0 ? ' backgroundTableLightBlue' : ''; 
        let importe = movimientosSinConfirmar.nImporte;
        let importeNegativo = false;

        if(importe < 0) importeNegativo = true;

        importe = JSON.parse(JSON.stringify(GlobalHelper.ConversionDeMilesAgregandoDecimales(importe)));

        if(importeNegativo){
            importe = importe.replace("-","(") 
            importe += ")"
        }  
        
        return ( 
            <tr className={'Block Personeria paddingLeftXS paddingTopBottom' + backColor}>
                <td style={{width:'110px'}}>
                    {movimientosSinConfirmar.dFecha.substr(0,10)}
                </td>
                <td style={{width:'524px', alignContent:'left'}}>
                    {movimientosSinConfirmar.vConcepto}
                </td>
                <td style={{width:'110px', alignContent: 'left'}}>
                    {importe}
                </td>
            </tr>
         );
      
}

export default RowTablaMovimientosSinConfirmar;